import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {getETLStatuses} from 'SystemAdministration/ducks/etlDashboard';
import {pipe} from 'fp-ts/lib/pipeable';
import {ReducerState} from 'rootReducer';
import {toEither} from 'Core/models/Async';
import * as E from 'fp-ts/lib/Either';
import {renderAsync} from 'Shared/components/RenderAsync';
import ETLCard from 'SystemAdministration/components/ETLCard';
import './ETLDashboard.sass';

const ETLDashboard = () => {
  const dispatch = useDispatch();
  const etlStatuses = useSelector((state: ReducerState) => state.etlStatuses);

  useEffect(() => {
    dispatch(getETLStatuses());
  }, []);

  return pipe(
    toEither(etlStatuses),
    E.fold(renderAsync, loadedStatuses => {
      return loadedStatuses.content.length > 0 ? (
        <div className="etl-dashboard">
          <h1 className="etl-dashboard__title">ETL Status Dashboard</h1>
          <p className="etl-dashboard__description">
            Below is a list of all of the Renaissance ETL's that support the MyAccess Portal along with their current
            status.
          </p>
          <div className="etl-dashboard__content">
            <div className="etl-dashboard__card-container">
              {loadedStatuses.content.map(etlStatus => (
                <ETLCard etlStatus={etlStatus} />
              ))}
            </div>
          </div>
        </div>
      ) : (
        <span>No ETL Statuses Available</span>
      );
    })
  );
};

export default ETLDashboard;
